import { render, staticRenderFns } from "./ProfileConfirmed.vue?vue&type=template&id=e57444a0"
import script from "./ProfileConfirmed.vue?vue&type=script&lang=js"
export * from "./ProfileConfirmed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports